import { program } from "./cli/index.js"

program.parse()
